import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import { cacheInvitedSitterData, consumeInvitedSitterToken, removeInvitedSitterCachedData } from '@/helpers/backupCareHelper';
import { checkJwtRoles } from '@/router/guards/helpers';

const confirmationStoreGuard = (to: Route, _from: Route, next: NavigationGuardNext) => {
  if (store.getters.selectedSitterUUID || store.getters.invitedSitterEmail) {
    next();
    return;
  }

  next(`/backup-care/${to.params.careSessionId}/new/invite`);
};

export const invitedSitterTokenGuard = async (to: Route, _from: Route, next: NavigationGuardNext) => {
  const {
    interview_request_id: interviewRequestId,
    invited_sitter_token: invitedSitterToken,
    invited_sitter_id: invitedSitterId,
  } = to.params;
  const account = store.getters['account/getAccount'];

  const redirectToSignup = () => {
    cacheInvitedSitterData(interviewRequestId, invitedSitterToken, invitedSitterId);
    next({
      path: '/sitter/signup/account',
      query: { return_path: window.location.pathname + window.location.search },
    });
  };

  const redirectToParentDashboard = () => {
    next('/account/seekers/dashboard');
  };

  const redirectToRequests = async () => {
    try {
      await consumeInvitedSitterToken(interviewRequestId, invitedSitterToken, invitedSitterId);
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Failed to consume invited sitter token before redirect.', error);
      }
    } finally {
      next(`/requests/${interviewRequestId}`);
      removeInvitedSitterCachedData();
    }
  };

  if (!account || (typeof account.isParent !== 'function' && typeof account.isSitter !== 'function')) {
    const jwtCheck = checkJwtRoles();

    if (!jwtCheck.hasRoles) {
      redirectToSignup();
      return;
    }

    if (jwtCheck.isParent) {
      redirectToParentDashboard();
      return;
    }

    if (jwtCheck.isSitter) {
      await redirectToRequests();
      return;
    }

    redirectToSignup();
    return;
  }

  if (account.isParent()) {
    redirectToParentDashboard();
    return;
  }

  if (account.isSitter()) {
    await redirectToRequests();
    return;
  }

  redirectToSignup();
};

export default confirmationStoreGuard;
